module.exports = __webpack_public_path__ + "images/576420c.png";